import { createRoutine } from 'redux-saga-routines';
//////////////////////////////////////////////////

const MODAL = 'MODAL';

const modalRoutine = createRoutine(MODAL);

export {
  modalRoutine,
};
